// キャンバス名（タイトル）の共有制約。
// REST のメタ更新・初回の名前入力・lazy create の名前のクランプと、画面の入力欄の上限で同じ値を使う。
// 数え方は UI と API でそろえ、どちらも JavaScript の文字列長（UTF-16 のコード単位。HTML の maxlength と
// zod の max と同じ）で数える。

/** キャンバス名の最大長。 */
export const CANVAS_TITLE_MAX_LENGTH = 120;
